import {
  IGetNotificationResponse,
  IGetTopicResponse,
  IPatchNotificationRequest,
  IPostNotificationRequest,
} from "../../interface/notification";
import request, { BaseResponse } from "../core";

export const getNotification = async () => {
  return await request.get<BaseResponse<IGetNotificationResponse[]>>(
    `/app/push/subscriber`
  );
};

export const getTopic = async () => {
  return await request.get<BaseResponse<IGetTopicResponse[]>>(
    `/app/push/topic`
  );
};

// patch는 등록된 구독 정보를 수정하는 요청이고, post는 웹 단에서 최초 회원가입 시 알림 기기 구독을 등록하는 요청입니다.

export const patchNotification = async (data: IPatchNotificationRequest) => {
  return await request.patch<BaseResponse<boolean>>(
    `/app/push/subscriber/topic`,
    data
  );
};

export const postNotification = async (data: IPostNotificationRequest) => {
  return await request.post<BaseResponse<boolean>>(
    `/app/push/subscriber/topic`,
    data
  );
};

/**
 * 안내 알림(클래스룸·챌린지·문의 답변) 수신 여부.
 *
 * 학습 알림과 별개다. 그쪽은 patchNotification 의 status 로 켜고 끈다.
 */
export const getNoticePush = async () => {
  return await request.get<BaseResponse<boolean>>(`/app/push/notice-setting`);
};

export const patchNoticePush = async (enabled: boolean) => {
  return await request.patch<BaseResponse<boolean>>(
    `/app/push/notice-setting?enabled=${enabled}`
  );
};
